import * as ActionTypes from '../actions/index';
import {fromJS} from "immutable";
import {createReducer} from "./index";

const INITIAL_STATE = fromJS({
  fetching: false,
  operatorGroups: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  orderBy: 0,
  order: 'desc',
  errorMessage: undefined,
  changedOperatorGroup: undefined,
});

function getOperatorGroups(state, action) {
  return state.set('fetching', true);
}

function getOperatorGroupsSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('operatorGroups', fromJS(action.payload.body))
}

function getOperatorGroupsFailed(state, action) {
  return state.set('fetching', false);
}

function countOperatorGroups(state, action) {
  return state;
}

function countOperatorGroupsSuccess(state, action) {
  return state
    .set('total', action.payload.body.count)
}

function countOperatorGroupsFailed(state, action) {
  return state;
}

function storeTemporaryOperatorGroupImage(state, action) {
  return state;
}

function createOperatorGroup(state, action) {
  return state;
}

function createOperatorGroupSuccess(state, action) {
  return state;
}

function createOperatorGroupFailed(state, action) {
  return state;
}

function changeOperatorGroupPreferences(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

function changeOperatorGroupsOrder(state, action) {
  return state
    .set('order', action.payload.order)
    .set('orderBy', action.payload.orderBy)
}

function storeTemporaryProductOperatorGroupImage(state, action) {
  return state;
}

function editOperatorGroup(state, action) {
  return state;
}

function editOperatorGroupFailed(state, action) {
  return state;
}

function copyOperatorGroupForEdit(state, action) {
  const operatorGroupId = action.payload;
  const operatorGroup = state
    .get('operatorGroups').valueSeq().toArray()
    .filter(operatorGroupImmutable =>
      String(operatorGroupImmutable.get('id')) === String(operatorGroupId))[0];
  return state.set('changedOperatorGroup', operatorGroup );
}

function editOperatorGroupField(state, action) {
  return state
    .setIn(['changedOperatorGroup', action.payload.field], action.payload.value);
}

function deleteOperatorGroupFailed(state, action) {
  let errorMessage = null;
  try {
    errorMessage = action.payload.response.body.error.message
  } catch (e) {
    errorMessage = 'Failed to delete the operator group'
  }

  return state
    .set('errorMessage', errorMessage)
}

function clearProductOperatorGroupDeleteErrorMessage(state, action) {
  return state.set('errorMessage', undefined);
}

export const operatorGroups = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_OPERATOR_GROUPS]: getOperatorGroups,
  [ActionTypes.GET_OPERATOR_GROUPS_SUCCESS]: getOperatorGroupsSuccess,
  [ActionTypes.GET_OPERATOR_GROUPS_FAILED]: getOperatorGroupsFailed,
  [ActionTypes.COUNT_OPERATOR_GROUPS]: countOperatorGroups,
  [ActionTypes.COUNT_OPERATOR_GROUPS_SUCCESS]: countOperatorGroupsSuccess,
  [ActionTypes.COUNT_OPERATOR_GROUPS_FAILED]: countOperatorGroupsFailed,
  [ActionTypes.CREATE_OPERATOR_GROUP]: createOperatorGroup,
  [ActionTypes.CREATE_OPERATOR_GROUP_SUCCESS]: createOperatorGroupSuccess,
  [ActionTypes.CREATE_OPERATOR_GROUP_FAILED]: createOperatorGroupFailed,
  [ActionTypes.CHANGE_OPERATOR_GROUP_PREFERENCES]: changeOperatorGroupPreferences,
  // [ActionTypes.CHANGE_OPERATOR_GROUPS_ORDER]: changeOperatorGroupsOrder,
  [ActionTypes.STORE_TEMPORARY_PRODUCT_LABEL_IMAGE]: storeTemporaryProductOperatorGroupImage,
  [ActionTypes.EDIT_OPERATOR_GROUP]: editOperatorGroup,
  [ActionTypes.EDIT_OPERATOR_GROUP_FAILED]: editOperatorGroupFailed,
  [ActionTypes.COPY_OPERATOR_GROUP_FOR_EDIT]: copyOperatorGroupForEdit,
  [ActionTypes.EDIT_OPERATOR_GROUP_FIELD]: editOperatorGroupField,
  // [ActionTypes.CLEAR_TEMP_UPLOADED_PRODUCT_OPERATOR_GROUP]: clearOperatorGroupTempImage,
  [ActionTypes.DELETE_OPERATOR_GROUP_FAILED]: deleteOperatorGroupFailed,
  [ActionTypes.CLEAR_PRODUCT_OPERATOR_GROUP_DELETE_ERROR_MESSAGE]: clearProductOperatorGroupDeleteErrorMessage,
});



// WEBPACK FOOTER //
// ./src/reducers/operatorGroups.js